import { toClass, toClasses } from 'class-converter';
import DeclarationVente, { ChildrenSrcEspece } from 'mpm-classes/DeclarationVente';
import MPMContext from 'mpm-config/context/MPMContext';
import Services from 'mpm-services';
import React from 'react';
import LignesEspeces, { LignesExistants } from './LignesEspeces';

export default ({ declarationVente, setDeclarationVente, setMessage, editMode, pays, onClickDelete, updateMode }) => {
  const [lignesExistants, setLignesExistants] = React.useState(toClasses(declarationVente.existingChildrenSrcEspeceDV, ChildrenSrcEspece));
  const [lignesEspeces, setLignesEspeces] = React.useState(toClasses(declarationVente.childrenSrcEspeceDV, ChildrenSrcEspece));

  React.useEffect(() => {
    setDeclarationVente(toClass({ ...declarationVente, childrenSrcEspeceDV: lignesEspeces, existingChildrenSrcEspeceDV: lignesExistants }, DeclarationVente));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lignesExistants, lignesEspeces]);

  const onAddRow = (row) => {
    setMessage(null);
    if (!isValidToAdd(row)) {
      setMessage({
        warning: true,
        header: 'Validation',
        content: `Veuillez vérifier votre lignes avant de l'ajouté.`,
      });
      return;
    } else if (isExists(row)) {
      setMessage({
        warning: true,
        header: 'Validation',
        content: `Cette ligne existe déjà.`,
      });
      return;
    }
    setLignesExistants(
      lignesExistants.map((ligne) => {
        if (ligne.refEspece.id === row.refEspece.id) {
          ligne.poidsADebarqueEstime -= row.quantite;
        }
        ligne.id_refPaysExp = '';

        return ligne;
      })
    );
    setLignesEspeces([...lignesEspeces, toClass({ ...row, id: null }, ChildrenSrcEspece)]);
  };

  const onDeleteRow = (row, index) => {
    if (row.id) {
      if (updateMode && lignesEspeces?.length === 1) {
        onClickDelete(declarationVente);
        return;
      }
      setMessage({
        info: true,
        header: 'Suppression',
        content: 'Suppression en cours, veuiillez patienter...',
      });
      Services.DeclarationVenteService.deleteSubElement(row.id)
        .then((result) => {
          if (result.success) {
            setMessage({
              success: true,
              header: 'Succès',
              content: result.message,
            });
            onContinueDeleteRow(row, index);
          } else {
            setMessage({
              warning: true,
              header: 'Attention',
              content: result.message,
            });
          }
        })
        .catch((error) => {
          setMessage({
            error: true,
            header: 'Erreur',
            content: 'Attention: une erreur est survenue lors de la suppression de la ligne',
          });
        });
    } else {
      setMessage(null);
      onContinueDeleteRow(row, index);
    }
  };

  const onContinueDeleteRow = (row, index) => {
    setLignesExistants(
      lignesExistants.map((ligne) => {
        if (ligne.refEspece.id === row.refEspece.id) {
          ligne.poidsADebarqueEstime += row.quantite;
        }
        return ligne;
      })
    );
    const newLignesEspeces = [...lignesEspeces];
    newLignesEspeces.splice(index, 1);
    setLignesEspeces(newLignesEspeces);
  };

  const isValidToAdd = (row) => {
    const isPoulpe = row?.refEspece?.id === 1574076 || row?.refEspece?.id === 869246;
    if (isPoulpe) {
      return Boolean(row.refEspece && row.quantite && row.id_refPaysExp && row.valeur && row.tailleCommerciale && row.quantite <= row.poidsADebarqueEstime);
    } else {
      return Boolean(row.refEspece && row.quantite && row.id_refPaysExp && row.valeur && row.quantite <= row.poidsADebarqueEstime);
    }
  };
  const isExists = (row) => {
    return Boolean(lignesEspeces.find((ligne) => ligne.refEspece.id === row.refEspece.id && ligne.id_refPaysExp === row.id_refPaysExp && ligne.tailleCommerciale === row.tailleCommerciale));
  };

  return (
    <MPMContext.Consumer>
      {(context) => (
        <>
          <LignesExistants dataSet={lignesExistants} onAddRow={(row) => onAddRow(row)} editMode={editMode} pays={pays} />

          <LignesEspeces dataSet={lignesEspeces} onDeleteRow={(row, index) => onDeleteRow(row, index)} editMode={editMode} pays={pays} />
        </>
      )}
    </MPMContext.Consumer>
  );
};
